import { KeyboardEventHandler, ReactNode } from 'react';
import styles from './StepLayout.module.css';

const Header = ({ children }: { children: ReactNode }) => <div>{children}</div>;

const Title = ({ children }: { children: ReactNode }) => (
  <h1 className={styles.title}>{children}</h1>
);

const Description = ({ children }: { children: ReactNode }) => (
  <p className={styles.content}>{children}</p>
);

const Actions = ({ children }: { children: ReactNode }) => (
  <div className={styles.actions}>{children}</div>
);

const Content = ({ children }: { children: ReactNode }) => (
  <div className={styles.content}>{children}</div>
);

const StepLayout = ({
  onKeyDown,
  children,
}: {
  children: ReactNode;
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>;
}) => {
  return (
    <div className={styles.container} onKeyDown={onKeyDown}>
      {children}
    </div>
  );
};

StepLayout.Header = Header;
StepLayout.Title = Title;
StepLayout.Description = Description;
StepLayout.Actions = Actions;
StepLayout.Content = Content;

export default StepLayout;
